var introElements = document.querySelectorAll('.intro')

for ( var i = 0; i < introElements.length; i++ ) {
    var intro = introElements[i]
    initIntro(intro)
}

function initIntro(intro) {
    var buttonMore = intro.nextElementSibling
    var buttonLess = intro.nextElementSibling.nextElementSibling

    buttonMore.addEventListener('click', (event) => {
        event.preventDefault()

        buttonMore.classList.add('is-hidden')
        buttonLess.classList.remove('is-hidden')
        intro.classList.remove('intro--gradient')
    })

    buttonLess.addEventListener('click', (event) => {
        event.preventDefault()
        buttonMore.classList.remove('is-hidden')
        buttonLess.classList.add('is-hidden')
        intro.classList.add('intro--gradient')
    })
}


// WEBPACK FOOTER //
// ./scripts/components/intro.js